import React from 'react';
import './App.css';
import { store } from './store';
import AppBrowserRouter from './AppBrowserRouter';
import { Provider } from 'react-redux';
import { Alert } from './components/common';
import LoadingSpinner from 'components/common/LoadingSpinner';

function App() {
    return (
        <Provider store={store}>
            <AppBrowserRouter />
            <Alert />
            <LoadingSpinner />
        </Provider>
    );
}

export default App;
